import React, { useEffect, useState } from "react";
import { functions } from "../../../../constants/common-functions";
import { GREY_GRADIENT_PANEL_BACKGROUND } from "../../../../constants/styles";
import {ADMIN_PANEL_BACKGROUND_COLOR } from "../../../../constants/styles";

export default function ResponseDetailModal({ open, onClose, onReissue, responseId }) {

	const [responseDetails, setResponseDetails] = useState(null);

	   useEffect(function () {

	       if (open && responseId) {
	           loadResponseDetails(responseId);
	       }

	   }, [open, responseId]);

	   const loadResponseDetails = function (thisResponseId) {

	       functions.getObjectFromAjax(
	           "/resolutionsoftwareplatform/questionnaire/response/details/" + thisResponseId,
	           null, handleResponseDetails
	       );

	   };

	const handleResponseDetails = (obj) => {
		console.log("QUESTIONNAIRE RESPONSE");
		console.log(obj);
		setResponseDetails(obj);
	};

	   if (!open) return null;

	   /* ====================================================== */
	   /*  STYLES                                                */
	   /* ====================================================== */

	   const overlayStyle = {
	       position: "fixed",
	       top: 0,
	       left: 0,
	       width: "100vw",
	       height: "100vh",
	       background: "rgba(0,0,0,0.35)",
	       zIndex: 30000,
	       display: "flex",
	       justifyContent: "center",
	       alignItems: "center"
	   };

	   const modalStyle = {
	       width: "1000px",
	       height: "80vh",
	       background: ADMIN_PANEL_BACKGROUND_COLOR,
	       borderRadius: "12px",
	       display: "flex",
	       flexDirection: "column",
	       boxShadow: "0 20px 40px rgba(0,0,0,0.25)",
	       overflow: "hidden"
	   };

	   const headerStyle = {
	       padding: "16px 20px",
	       borderBottom: "1px solid #ddd",
	       background: GREY_GRADIENT_PANEL_BACKGROUND
	   };

	   const titleStyle = {
	       fontSize: "16px",
	       fontWeight: "600",
	       color: "#222"
	   };

	   const metaStyle = {
	       fontSize: "12px",
	       color: "#666",
	       marginTop: "4px"
	   };

	   const contentStyle = {
	       padding: "20px",
	       overflowY: "auto",
	       flex: 1
	   };

	   const questionStyle = {
	       marginBottom: "16px",
	       paddingBottom: "12px",
	       borderBottom: "1px solid #eee"
	   };

	   const questionText = {
	       fontSize: "13px",
	       fontWeight: "600",
	       color: "#333"
	   };

	   const answerText = {
	       fontSize: "12px",
	       color: "#444",
	       marginTop: "6px"
	   };

	   const commentText = {
	       fontSize: "12px",
	       color: "#777",
	       marginTop: "4px",
	       fontStyle: "italic"
	   };

	   const footerStyle = {
	       padding: "12px 20px",
	       borderTop: "1px solid #ddd",
	       display: "flex",
	       justifyContent: "flex-end",
	       background: GREY_GRADIENT_PANEL_BACKGROUND
	   };

	   const buttonStyle = {
	       padding: "6px 16px",
	       borderRadius: "6px",
	       border: "1px solid #ccc",
	       background: "linear-gradient(180deg, #f4f6f8, #e6e8eb)",
	       cursor: "pointer",
	       fontSize: "12px",
	       fontWeight: "600"
	   };

	   /* ====================================================== */
	   /*  LOADING STATE                                         */
	   /* ====================================================== */

	   if (!responseDetails) {
	       return (
	           <div style={overlayStyle}>
	               <div style={modalStyle}>
	                   <div style={contentStyle}>Loading response...</div>
	               </div>
	           </div>
	       );
	   }

	   /* ====================================================== */
	   /*  RENDER                                                */
	   /* ====================================================== */

	   return (
	       <div style={overlayStyle}>
	           <div style={modalStyle}>

	               {/* HEADER */}
	               <div style={headerStyle}>
	                   <div style={titleStyle}>Response Details</div>
	                   <div style={metaStyle}>
	                       {responseDetails.questionnaireTitle} | {responseDetails.username} | {responseDetails.completedDate}
	                   </div>
	               </div>

	               {/* CONTENT */}
	               <div style={contentStyle}>

	                   {responseDetails.answers.map(function (a, idx) {

	                       return (
	                           <div key={idx} style={questionStyle}>
	                               <div style={questionText}>
	                                   {a.questionText}
	                               </div>
	                               <div style={answerText}>
	                                   Answer: {a.answerScore}
	                               </div>
	                               {a.answerComment && (
	                                   <div style={commentText}>
	                                       Comment: {a.answerComment}
	                                   </div>
	                               )}
	                           </div>
	                       );

	                   })}
					<div style={questionText}>
	                       Overall Comments:
	                   </div>
	                   <div style={answerText}>
	                      {responseDetails.overallComments}
	                   </div>
	               </div>

	               {/* FOOTER */}
	               <div style={footerStyle}>
	                   <button style={buttonStyle} onClick={onClose}>Close</button>
	               </div>

	           </div>
	       </div>
	   );
}
